/**
 * tab.component.ts
 *
 * The purpose of this class is to provide base methods for updating a patient's
 * information from a tab.
 *
 * The parent component is assumed to be the PatientDashboard component of this project.
 */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { PatientDashboardStore } from '../../state/dashboard-page.store';
import { Store } from '@ngrx/store';
import { selectIsAdmin } from 'src/app/calvin-emr-shared/state/auth/auth.selector';

@Component({
  selector: 'app-base',
  template: ` <p>tab works!</p> `,
  styles: [],
  standalone: true,
})
export class PatientDashboardTabComponent implements OnInit, OnDestroy {
  // For loading
  isLoading = true;
  isAdmin = false;

  patient$: Observable<Patient>;
  isAdminSub: Subscription;

  constructor(private patientStore: PatientDashboardStore, private store: Store) {
    this.patient$ = this.patientStore.patient$.pipe(takeUntil(patientStore.destroy$));
    this.isAdminSub = this.store.select(selectIsAdmin).subscribe((isAdmin) => {
      this.isAdmin = isAdmin;
    });
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.isAdminSub.unsubscribe();
  }

  startLoading(): void {
    this.isLoading = true;
  }

  stopLoading(): void {
    this.isLoading = false;
  }

  updatePatientField(field: string, data: any) {
    this.patientStore.setField({ field: field, data: data });
  }
}
